import { useEffect, useState } from "react";
import { readChart, subscribeChart } from "../utils/chordBarsClipboard";

// The chart waiting to be pasted, kept current when a copy is made elsewhere
const useCopiedChart = () => {
  const [chart, setChart] = useState(readChart);

  useEffect(() => subscribeChart(setChart), []);

  return chart;
};

export default useCopiedChart;
